// src/contexts/CurrencyContext.js

import React, { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext();

const getCurrencyObject = (code) => {
  switch (code) {
    case 'SEK':
      return { symbol: 'kr', label: 'SEK' };
    case 'RON':
      return { symbol: 'lei', label: 'RON' };
    default:
      return { symbol: '€', label: 'EUR' };
  }
};

export const CurrencyProvider = ({ children }) => {
  const savedCode = localStorage.getItem('currencyCode') || 'EUR';
  const [currencyCode, setCurrencyCode] = useState(savedCode);
  const [currency, setCurrency] = useState(getCurrencyObject(savedCode));

  const changeCurrency = (code) => {
    const newCurrency = getCurrencyObject(code);
    setCurrency(newCurrency);
    setCurrencyCode(code);
    localStorage.setItem('currencyCode', code);
  };

  return (
    <CurrencyContext.Provider value={{ currency, currencyCode, changeCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);